/**
 * Identifica a recusa do backend por falta de caixa aberto do usuário na filial.
 *
 * Extraído da venda (OrderNew) para o consumo do colaborador oferecer a mesma saída: perguntar
 * se quer abrir o caixa em vez de só mostrar o erro. A busca é por texto porque o backend
 * devolve a mensagem traduzida, e ela existe em versões diferentes (inclusive uma legada com
 * dois espaços). Serializar o payload garante que a checagem continue funcionando se a API
 * mudar só o campo em que manda a mensagem, sem confundir outros erros com falta de caixa.
 */
export const isNoOpenCashError = (error) => {
    const responseData = error?.response?.data;
    const errorMessage = typeof responseData === 'string'
        ? responseData
        : [
            responseData?.message,
            responseData?.error,
            responseData?.detail,
            ...(Array.isArray(responseData?.errors) ? responseData.errors : [])
        ].filter(Boolean).map(value => typeof value === 'string' ? value : JSON.stringify(value)).join(' ');

    const searchable = `${errorMessage} ${error?.message || ''} ${JSON.stringify(responseData || '')}`
        .normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();

    return /nao existe caixa em\s+aberto|nao ha caixa.*abert|nao foi encontrado caixa aberto|no open cash|open cash/.test(searchable);
};

export default isNoOpenCashError;
